import React, { useContext, useState, useEffect } from 'react';
import styles from "../../../styles/components/UI/SettingsModal.module.css"
import CloseIcon from '@mui/icons-material/Close';
import PublicIcon from '@mui/icons-material/Public';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import { LangContext } from '../../../context/LangContext';

import { ThemeContext } from '../../../context/ThemeContext'; 

const translations = {
  ru: {
    settings: 'Настройки',
    language: 'Язык',
    theme: 'Тема',
    lightTheme: 'Светлая',
    darkTheme: 'Темная',
    languageSelection: 'Выбор языка',
  },
  en: {
    settings: 'Settings',
    language: 'Language',
    theme: 'Theme',
    lightTheme: 'Light',
    darkTheme: 'Dark',
    languageSelection: 'Language selection',
  },
};

export const SettingsModal = ({ onClose }) => {
  const { langSelected, setLangSelected } = useContext(LangContext);
  const { theme, toggleTheme } = useContext(ThemeContext); 

  const currentTranslation = translations[langSelected] || translations.ru;

  const languages = [
    { code: 'ru', name: 'Русский' },
    { code: 'en', name: 'English' },
  ];

  const themes = [
    { name: currentTranslation.lightTheme, value: 'light', color: '#f5f5f5' },
    { name: currentTranslation.darkTheme, value: 'dark', color: '#333333' },
  ];

  const handleLanguageChange = (lang) => {
    setLangSelected(lang);
  };


  const handleThemeChange = (selectedTheme) => {
    toggleTheme(selectedTheme);
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>

      <div className={`${styles.modalContent} ${theme === 'dark' ? styles.darkContent : ''}`} onClick={e => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>{currentTranslation.settings}</h2>
          <button className={styles.closeButton} onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className={styles.modalBody}>
          <div className={styles.settingGroup}>
            <div className={styles.settingHeader}>
              <PublicIcon className={styles.settingIcon} />
              <h3 className={styles.settingTitle}>{currentTranslation.language}</h3>
            </div>
            <div className={styles.languageOptions}>
              {languages.map(lang => (
                <button
                  key={lang.code}
                  className={`${styles.languageButton} ${langSelected === lang.code ? styles.activeLanguage : ''}`}
                  onClick={() => handleLanguageChange(lang.code)}
                >
                  {lang.name}
                </button>
              ))}
            </div>
          </div>
          <div className={styles.settingGroup}>
            <div className={styles.settingHeader}>
              <Brightness4Icon className={styles.settingIcon} />
              <h3 className={styles.settingTitle}>{currentTranslation.theme}</h3>
            </div>
            <div className={styles.themeOptions}>
              {themes.map(t => (
                <button
                  key={t.value}

                  className={`${styles.themeButton} ${theme === t.value ? styles.activeTheme : ''}`} 
                  style={{ backgroundColor: t.color }}
                  onClick={() => handleThemeChange(t.value)}
                >
                  <span className={styles.themeName}>{t.name}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
